import axios from "axios";
import router from "@/router";
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
axios.defaults.headers.common["Accept-Language"] = localStorage.lang ?? "ar";
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) return Promise.reject(error);
    if (error.response.status === 401 && router.app.$route.name !== "Login") {
      router.push({ name: "Login" });
      localStorage.removeItem("userData");
    }
    return Promise.reject(error);
  }
);

let userData = JSON.parse(localStorage.getItem("userData"));
if (userData) {
  const token = userData.token;
  axios.defaults.headers.common["Authorization"] = `Bearer ` + token;
}
